

import React, {useEffect,useState, useReducer} from 'react';
import {Link} from "react-router-dom";

import {_getCoutryGoogleChartName} from '../../helpers/helpers.js'
import TechnologySmallIcon from '../../components/technologySmallIcon.js'

import ScanDomainTechnologies from '../../components/scanTechnologyList.js'
import StartMonitoring from '../../components/startMonitoringButton.js';

import {APIResponse} from '../../../../server/routes/route-types.js'
import {RtScanResults, RtHydratedTechnology, RtDomainInfo, RtCVEScanResultsPageResult} from '../../../../server/routes/cve-security-scan.js'

// // Interface for technology information
// interface TechnologyInfo {
//     ShortName: string;
//     Icon: string;
//     URL: string;
//     VersionTo: string;
//     VersionToInclusive: boolean;
//     Category: string;
//     CategoryURL: string;
// }

// // Interface for technology data
// interface TechnologyData {
//     Technology: string;
//     Category: string;
//     Icon?: string;
//     URL?: string;
// }

// // Interface for domain info
// interface DomainInfo {
//     redirect?: string;
// }

// // Interface for scan results
// interface ScanResults {
//     status: string;
//     domainInfo?: DomainInfo;
//     technologies?: TechnologyData[];
//     error?: string;
//     canDetectVulnerability?: boolean;
//     detectedTechnology?: boolean;
//     technology?: string;
//     version?: string;
//     vulnerable?: boolean;
//     cannotDetectVulnerabilityReason?: string;
// }

// // Interface for page data
// interface CVEScanResultsPageData {
//     Domain: string;
//     CVE: string;
//     ScanId: string;
//     CanonicalURL: string;
//     CVEDescription?: string;
//     TechnologyInfo: TechnologyInfo;
//     ScanResults?: ScanResults;
// }

// Interface for component props
interface CVEScanResultsProps {
    server: string;
    pageData: unknown;
}

// Interface for scan state
interface ScanState {
    status: string;
    domainInfo: RtDomainInfo | null;
    detectedTechnology?: string;
    version?: string;
    vuln?: string;
    explanation?: string;
    technologies?: RtHydratedTechnology[] | null;
}

// Interface for component props
interface CVEScanResultProps {
    props: RtCVEScanResultsPageResult;
}

interface DomainInfoProps {
    domainInfo: RtDomainInfo | null;
}

interface DisplayVulnStatusProps {
    status: string;
}

// Type for reducer actions
type ReducerAction = [string, Partial<ScanState>];


export default function ScanResults({server, pageData}: CVEScanResultsProps) {

	let [data, setData] = useState(pageData as RtCVEScanResultsPageResult);

	if (!data.Domain) return  (<></>);
	if (!data.CVE) return  (<></>);

	return (
        <>
             <section className="section section-sm">
				<h3 className="text-left mb-3">
				<b>Security Scan result</b>
				</h3>
				for website <b>{data.Domain}</b>
				<CVEScanResult  props={data}  /> 
            </section>
   
        </>
    )
}

function CVEScanResult({props}: CVEScanResultProps) {

	if (!props.Domain) return  (<></>);
	if (!props.CVE) return  (<></>);
	if (!props.ScanId) return  (<></>);

	const cve = props.CVE;
	const TechnologyInfo = props.TechnologyInfo;

//	const [ scanState, setScanState] = useState(1);
	const [ scanState, setScanState] = useState<number | boolean>(props.ScanResults && props.ScanResults.status=='completed' ? 0 : 1);
	const [ state, dispatch ] = useReducer( 
		CVEScanFormReducer, getStateFromResults(cve,props.ScanResults));

	useEffect(() => {
		if (scanState) { 
		  const intervalId = setInterval(() => {
			fetchScanResult(cve, props.ScanId);
		  }, 2000); // Refresh every 2 seconds
	
		  return () => clearInterval(intervalId);
		}
	}, [scanState]);	

	function getStateFromResults(cve: string, results: RtScanResults | undefined): ScanState {
		if (!results) return {			
			status: "Scheduling",
			domainInfo: null,
			// tech: "N/A",
			version: "N/A",
			vuln: "N/A",
			explanation: "N/A"
		};

		if (results.status == "running") {					
			return {
				status: 'Scan in progress '	,
				domainInfo: null,
				detectedTechnology: "N/A",
				version: "N/A",
				vuln: "N/A",
				explanation: "N/A",
				technologies: null
			}; 
		}
		else if (results.status == "completed") {
			let tech = null;

			if (results.technologies != null) {	
				tech = results.technologies.sort( 
					(a: RtHydratedTechnology, b: RtHydratedTechnology) => compareTechByCategory(a , b ));
			}		
			
			if (results.canDetectVulnerability == true){
				return {
					status: "Completed",
					domainInfo: results.domainInfo!,
					detectedTechnology: (results.detectedTechnology ? (results.technology + " detected") : "Not detected" ),
					version: results.version == null ? "Not detected" : results.version,
					vuln: results.vulnerable ? "Vulnerable" : "Not Vulnerable",
					explanation: results.vulnerable ? 
								`The website is vulnerable to ${cve}.` : 
								`The technology version used by the website is not vulnerable to ${cve}.`,
					technologies: tech
				};  
			} else {
				return {
					status: "Completed",
					domainInfo: results.domainInfo!,
					detectedTechnology: (results.detectedTechnology ? (results.technology + " detected") : "Not detected" ),
					version: results.version == null ? "Not detected" : results.version,
					vuln: results.vulnerable ? "Vulnerable" : "Detection Inconclusive",
					explanation: results.cannotDetectVulnerabilityReason,
					technologies: results.technologies
				};  
			}
		} 				
		else if (results.status == "failed") {
			return {
				status: results.error!,
				domainInfo: null,
				detectedTechnology: "N/A",
				version: "N/A",
				vuln: "N/A",
				explanation: "N/A",
				technologies: null
			};  
		} 		
		return {			
			status: 'Failed',
			domainInfo: null,
			explanation: 'scan failure'
		};
	}
	function processScanResults(cve: string, results: RtScanResults): void {
		if (!results) return;

		let state: ScanState = getStateFromResults(cve,results);

		console.log("state="+JSON.stringify(state));

		if (results.status == "running") {	
			if (typeof scanState === 'number' && scanState > 300) {
				// 10 minute : 600 sec / 2
				setScanState(0);					
				dispatch([ "error", {
					status: "Scan timeout"
				}]); 	
			} else {
				setScanState(typeof scanState === 'number' ? scanState + 1 : 1);					
				state.status += ' ';
				for (let i = 0; i < (typeof scanState === 'number' ? scanState : 0); i++) state.status += '.';
				dispatch([ "success", state]); 
			}
		}
		else if (results.status == "completed") {
			setScanState(0);
			dispatch([ "success", state]);  
		} 				
		else if (results.status == "failed") {
			setScanState(0);
			dispatch([ "success", state]);  
		} 
	}
	function fetchScanResult (cve: string, scanId: string): void {
	
	// https://127.0.0.1:3001/cve-security-scan/CVE-2024-40597/api-results?scanid=scan-12343234			
	
		fetch( `/cve-security-scan/${cve}/api-results?scanid=${scanId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
			body: null
		}).then((result: Response) => {
			return result.json();
		}).then((untypedData: unknown) => {
			const data = untypedData as APIResponse<RtScanResults>;

			if (data.err ) { 
				console.log("case 1");
				console.log(JSON.stringify(data));		
				setScanState(0);	

				if (data.result404 ) { 
					dispatch([ "error", {
						status: data.result404.title,
						explanation: data.result404.title
					}]); 
				} else {
					dispatch([ "error", {
						status: data.err,
						explanation: data.err
					}]); 
				}
			}
			else if (data.results ) { 
				console.log("case 2");			
				setScanState(typeof scanState === 'number' ? scanState + 1 : 1);	
				console.log(JSON.stringify(data));
				processScanResults(cve,data.results);
			} else {
				console.log("case 4");
				console.log(JSON.stringify(data));
				setScanState(false);
				dispatch([ "error", {
					status: 'Failed',
					explanation: 'scan failure'
				}]); 
			}
		}).catch((e: unknown) => {
			console.error( "Exception", e );
		});
	};   
	
	
	return (
		<>			
			<div className="row row-50">
			<div className="col-12">
				<table className="table-custom table-custom-striped table-custom-primary">
					<tbody>
						<tr>
							<td style={{width: '30%'}}>Scan status</td>
							<td style={{width: '70%', color: 'darkgreen'}}>
								<b>{ state.status }</b>
							</td>
						</tr>	
						<tr>
							<td>Testing for single CVE</td>
							<td>
								<span className="icon text-primary">
									<b>									
									<Link 
										to={`/cve/${cve}`}
										className="link-hover" 
										title={cve} 
									> {cve}
									</Link>
									</b>
								</span>
							</td>
						</tr>						
						<tr>
							<td>CVE Description</td>
							<td style={{color: 'black'}}>{props.CVEDescription ? props.CVEDescription : '-'}</td>
						</tr>						
						<tr>
							<td>Affected Technology</td>
							<td>
								<TechnologySmallIcon 
									technologyIcon={TechnologyInfo.Icon} 
									technology={TechnologyInfo.ShortName}
								/>&nbsp;
								<span className="icon text-primary">
									<b>									
									<Link 
										to={`/technology/${TechnologyInfo.URL}`}
										className="link-hover" 
										title={TechnologyInfo.ShortName} 
									> {TechnologyInfo.ShortName}
									</Link>
									</b>
								</span>
							</td>
						</tr> 	
						<tr>
							<td>
								Technology Detected?
							</td>
							<td style={{color: 'black'}}>
								{state.detectedTechnology}
							</td>						
						</tr> 		
						<tr>
							<td>
								Version Detected?
							</td>
							<td style={{color: 'black'}}>
								{state.version}
							</td>						
						</tr> 
						<tr>
							<td>
								Vulnerability Status
							</td>
							<td style={{color: 'black'}}>
								<DisplayVulnStatus status={state.vuln!} />
							</td>						
						</tr> 																		
						<tr>
							<td>
							Vulnerability Status Explanation
							</td>
							<td style={{color: 'black'}}>
								{state.explanation}
							</td>						
						</tr> 																		
					</tbody>
				</table>
				<DomainInfo domainInfo={state.domainInfo} />				
				{
					!!state.technologies &&	
					<StartMonitoring domain={props.Domain} />
				}
				{
					!!state.technologies &&
					<>
					<h3>Detected Technologies</h3>								
					<ScanDomainTechnologies technologies={state.technologies} link={props.CanonicalURL} />
					</>	
				}				
				<br/>
			</div>
		</div>		
		</>
		)
}

function DisplayVulnStatus({status}: DisplayVulnStatusProps)
{
	// "Vulnerable" : "Detection Inconclusive", "Not Vulnerable", "-"
	if (status == "Not Vulnerable") return (<b style={{color: 'darkgreen'}}>{ status }</b>);
	if (status == "Vulnerable") return (<b style={{color: 'darkred'}}>{ status }</b>);
	if (status == "Detection Inconclusive") return (<b style={{color: 'black'}}>{ status }</b>);

	return (<b style={{color: 'black'}}>{status}</b>);
}

function compareTechByCategory(a: RtHydratedTechnology | null, b: RtHydratedTechnology | null): number {
	// workaround null element
    if (a == null || b == null)
        return 0;// a < b;


    if (a.Category < b.Category)
        return -1;
    if (a.Category > b.Category)
        return 1;
    return 0;
}

const CVEScanFormReducer = function( state: ScanState, [ type, data ]: ReducerAction ): ScanState {
    if( type === "error" ){
		return {
			...state,
			status: data.status!,
			domainInfo: null,
			detectedTechnology: 'N/A',
			version: 'N/A',
			vuln: 'N/A',
			explanation: data.explanation,
			technologies: data.technologies
		};
	};   
    if( type === "success" ){
		return {
			...state,
			status: data.status!,
			domainInfo: data.domainInfo!,
			detectedTechnology: data.detectedTechnology,
			version: data.version,
			vuln: data.vuln,
			explanation: data.explanation,
			technologies: data.technologies
		};;
	};
    return state; 
};

function DomainInfo({domainInfo}: DomainInfoProps) {

	if (!domainInfo) return null;
	if (!domainInfo.redirect) return null;

	return (
		<div className="row row-50">
			<div className="col-12">
				<p style={{color: 'red'}}>
				Website redirects to <b>{domainInfo.redirect}</b>
				</p>
			</div>
		</div>
	)
}
